import { FC, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NotificationsList from '@/components/NotificationsList';

interface NotificationsPanelProps {
  onClose?: () => void;
}

/**
 * Popover de notificações ancorado no sidebar — "espiada rápida" das mais recentes.
 * A lógica de fetch/renderização vive em <NotificationsList />, reutilizada pela
 * página dedicada /notificacoes (NotificationsPage).
 */
const NotificationsPanel: FC<NotificationsPanelProps> = ({ onClose }) => {
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (panelRef.current && !panelRef.current.contains(event.target as Node)) {
        onClose?.();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <div
      ref={panelRef}
      className="w-[min(384px,calc(100vw-2rem))] max-h-[min(600px,calc(100vh-8rem))] bg-surface-secondary border border-theme-border rounded-xl shadow-2xl overflow-hidden z-50 flex flex-col"
    >
      {/* Header */}
      <div className="p-4 border-b border-theme-border bg-surface-primary">
        <h3 className="text-lg font-bold text-content-primary">Notificações</h3>
      </div>

      {/* Lista (scrollável) */}
      <div className="flex-1 overflow-y-auto">
        <NotificationsList variant="popover" onNavigate={onClose} />
      </div>

      {/* Link pra página dedicada */}
      <div className="px-4 py-3 border-t border-theme-border bg-surface-primary">
        <Link
          to="/notificacoes"
          onClick={() => onClose?.()}
          className="text-sm text-accent hover:text-accent-hover font-medium"
        >
          Ver todas →
        </Link>
      </div>
    </div>
  );
};

export default NotificationsPanel;
